import { createContext } from 'react';

/** O ancestral que rola a página de resultados (`overflow-y: auto|scroll`), se houver. */
export function scrollParentOf(el: HTMLElement): HTMLElement | null {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const { overflowY } = getComputedStyle(node);
    if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') return node;
  }
  return null;
}

/** A marca do `<main>` que rola a lista no `ResultsLayout` com `listScroll: 'own'`. */
export const RESULTS_LIST_SCROLLER_ATTR = 'data-results-list-scroller';

/** O scroller da lista do `ResultsLayout` dentro de `root`, quando a página rola por conta
 *  própria (`listScroll: 'own'`) — para o host que precisa reposicionar a lista sem
 *  conhecer a anatomia da página. */
export function resultsListScrollerOf(root: HTMLElement): HTMLElement | null {
  return root.querySelector<HTMLElement>(`[${RESULTS_LIST_SCROLLER_ATTR}]`);
}

/** Quem rola a lista do `ResultsLayout` agora (`host` ou `own`), para quem observa a
 *  rolagem de dentro dela. O `<main>` é o mesmo nos dois modos — só a classe muda
 *  com a largura —, então quem fixou o scroller numa medida (a raiz do observer da
 *  `LoadMoreSentinel`) precisa deste sinal para medir de novo. `null` fora do layout. */
export const ResultsListScrollContext = createContext<'host' | 'own' | null>(null);
